import { ApiService, UploadUrlsRequestTypeEnum } from 'js/src/client';
import { getGlobalUploadNetworkManager } from 'js/src/libs/upload-network-manager';

export function uploadVideoPoster(file: File, upload_url: string) {
    const uploadNetworkManager = getGlobalUploadNetworkManager();
    return uploadNetworkManager.queueTask(async () => {
        await fetch(upload_url, {
            method: 'PUT',
            body: file,
        });

        const url = new URL(upload_url);
        const pathEntries = url.pathname.split('/').filter((e) => e);
        const bucket = url.host;
        const file_name = decodeURIComponent(pathEntries[pathEntries.length - 1]);
        return {
            bucket,
            file_name,
        };
    });
}

export async function uploadVideoPosterBlob(
    blob: Blob | null,
    fileName: string,
    fileType: string,
    videoId: number,
) {
    if (!blob) {
        return;
    }
    try {
        const file = new File([blob], fileName, { type: fileType });
        const response = await ApiService.uploadUrlsCreate({
            body: {
                type: UploadUrlsRequestTypeEnum.SINGLE_REQUEST_UPLOAD,
                file_name: file.name,
            },
        });
        const { upload_url } = response.data;
        const { bucket, file_name } = await uploadVideoPoster(file, upload_url);
        await ApiService.videoPosterValidationUpdate({
            body: { bucket, file_name, video_id: videoId },
        });
    } catch (e: unknown) {
        // don't notify users of this error
    }
}
